import React from 'react';
import PropTypes from 'prop-types';
import JustAskListItem from 'justAskComponents/JustAskListItem';
import RaisedButton from 'material-ui/RaisedButton';
import FontIcon from 'material-ui/FontIcon';
import {List} from 'material-ui/List';
import Divider from 'material-ui/Divider';

class JustAskList extends React.Component {

    constructor(props) {
        super(props);
        this.saveJustAsk = this
            .saveJustAsk
            .bind(this);
    }

    saveJustAsk(e) {
        e.preventDefault();
        const {justAskDetails, orderId, justAskActions, accountNumber} = this.props;

        justAskDetails
            .get('details')
            .forEach((item) => {

                if (item.get('action') === 'add') {
                    justAskActions.justAskAddStarted({
                        jobNumber: orderId,
                        customerAccount: accountNumber,
                        quantity: item.get('quantity'),
                        transactionTypeId: item.get('transactionTypeId')
                    }, orderId);

                }
                if (item.get('action') === 'update') {
                    justAskActions.justAskUpdateStarted({
                        jobNumber: orderId,
                        customerAccount: accountNumber,
                        quantity: item.get('quantity'),
                        transactionID: item.get('transactionId'),
                        queueStatusTypeID: 1,
                        transactionTypeId: item.get('transactionTypeId')
                    }, orderId);
                }

            });

    }

    render() {
        const {justAskDetails, orderId, justAskActions, category, orderStatus} = this.props;

        if (!justAskDetails || !justAskDetails.get('details') || justAskDetails.get('details').count() === 0) {
            return null;
        }

        let inputsDisabled = false,
            orderStatusItem;

        const orderStatusList = orderStatus.getIn(['details', 'serviceOrderStatus']);

        if (orderStatusList) {
            orderStatusItem = orderStatusList.first();
        }

        if (orderStatusItem && orderStatusItem.get('dispatchStatus') !== 'IN_PROGRESS') {
            inputsDisabled = true;
        }

        let hasError = false;

        const resultStyle = {
            marginTop: '8px'
        };

        const rows = justAskDetails
            .get('details')
            .filter((item) => {
                return item.get('category') === category;
            })
            .map((item, index) => {

                if (item.get('error')) {
                    hasError = true;
                }
                return (<JustAskListItem
                    disabled={inputsDisabled}
                    key={'just_ask_' + index}
                    orderId={orderId}
                    justAsk={item}
                    justAskActions={justAskActions}/>);
            })
            .toJS();

        for (let i = rows.length - 1; i >= 0; --i) {

            rows.splice(i + 1, 0, < Divider key = {
                'divider_' + i
            } />);

        }

        const saveButtonStyle = {
            display: 'none'
        };

        if (hasError) {
            saveButtonStyle.display = '';
            saveButtonStyle.marginTop = '25px';

        }

        const result = (
            <List>{rows}</List>
        );

        const saveIcon = (
            <FontIcon className="material-icons">save</FontIcon>
        );

        return (
            <div>
                <div>

                    <div>
                        <RaisedButton
                            label="Retry Save"
                            icon={saveIcon}
                            primary={true}
                            style={saveButtonStyle}
                            onTouchTap={this.saveJustAsk}/></div>

                </div>

                <div style={resultStyle}>{result}

                </div>
            </div>
        );
    }
}

JustAskList.propTypes = {
    justAskDetails: PropTypes.object,
    orderId: PropTypes.string,
    justAskActions: PropTypes.object,
    orderStatus: PropTypes.object,
    accountNumber: PropTypes.string,
    category: PropTypes.string

};
export default JustAskList;



// WEBPACK FOOTER //
// ./src/components/just-ask/JustAskList.js